import axios from "../axios";
export const educationUser_data_board = (data) => {
  return axios({
    url: "/console/education/user_data_board",
    method: "GET",
    data: data,
  });
};
export const dataTodo = (data) => {
  return axios({
    url: "/con/data/w/todo",
    method: "GET",
    data: data,
  });
};
export const homeworkRanking = (data) => {
  return axios({
    url: "/console/education/homework_ranking",
    method: "GET",
    data: data,
  });
};
export const getTeacherLoginStatistics = (data) => {
  return axios({
    url: "/console/education/getTeacherLoginStatistics",
    method: "GET",
    data: data,
  });
};
export const getPublishStatistic = (data) => {
  return axios({
    url: "/console/homework/publishStatistic",
    method: "GET",
    data: data,
  });
};


// WEBPACK FOOTER //
// ./src/http/moudules/survey.js